import type { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import Collapse from "bootstrap/js/dist/collapse";
import IMask from "imask/holder";

export class PersonalInformation
{
	public Form: HTMLFormElement;
	public Validation: UnobtrusiveValidation;
	public ReferralCollapse: Collapse | null = null;

	constructor(validation: UnobtrusiveValidation, form: HTMLFormElement)
	{
		this.Validation = validation;
		this.Form = form;
		this.ConfigureReferralMethod();
		this.ConfigureInputMasks();
		this.ConfigureWorkLocation();
		this.ConfigureAgeGate();
		this.ConfigureCitizenship();
	}

	private ConfigureAgeGate = () =>
	{
		const is16OrOlderYes = document.getElementById("Is16OrOlderYes") as HTMLInputElement;
		const is16OrOlderNo = document.getElementById("Is16OrOlderNo") as HTMLInputElement;
		const is18OrOlderYes = document.getElementById("Is18OrOlderYes") as HTMLInputElement;
		const is18OrOlderNo = document.getElementById("Is18OrOlderNo") as HTMLInputElement;

		if (is16OrOlderYes)
		{
			document.querySelectorAll("input[name='Is16OrOlder']").forEach(input =>
			{
				input.addEventListener("change", (e) =>
				{
					this.Validation.Service.isFieldValid(is16OrOlderYes);
					this.Validation.Service.isFieldValid(is16OrOlderNo);
				});
			});
		}

		if (is18OrOlderYes)
		{
			document.querySelectorAll("input[name='Is18OrOlder']").forEach(input =>
			{
				input.addEventListener("change", (e) =>
				{
					this.Validation.Service.isFieldValid(is18OrOlderYes);
					this.Validation.Service.isFieldValid(is18OrOlderNo);
				});
			});
		}
	}

	private ConfigureCitizenship = () =>
	{
		const legallyAuthorizedToWorkYes = document.getElementById("LegallyAuthorizedToWorkYes") as HTMLInputElement;

		document.querySelectorAll("input[name='LegallyAuthorizedToWork']")?.forEach(input =>
		{
			input.addEventListener("change", (e) =>
			{
				this.Validation.Service.isFieldValid(legallyAuthorizedToWorkYes);
			});
		});
	}

	private ConfigureInputMasks = () =>
	{
		const postalCodeInput = document.getElementById("PostalCode") as HTMLInputElement;
		const emailInput = document.getElementById("Email") as HTMLInputElement;
		const phoneInput = document.getElementById("Phone") as HTMLInputElement;

		if (postalCodeInput !== null)
		{
			IMask(
				postalCodeInput,
				{
					mask: "00000[-0000]"
				}
			)
		}

		if (emailInput !== null)
		{
			IMask(
				emailInput,
				{
					mask: /^\S*@?\S*$/
				}
			)
		}

		if (phoneInput !== null)
		{
			IMask(
				phoneInput,
				{
					mask: '(000) 000-0000'
				}
			)
		}
	}


	private ConfigureReferralMethod = () =>
	{
		const referralMethod: HTMLSelectElement | null = document.getElementById("ReferralMethod") as HTMLSelectElement;

		referralMethod?.addEventListener("change", (event) =>
		{
			const method = referralMethod?.value;
			const collapseOtherReferral = document.querySelector("#collapseOtherReferral") as HTMLElement;
			const collapseInstance = Collapse.getOrCreateInstance(collapseOtherReferral, { toggle: false });

			if (method === "Other")
			{
				collapseInstance?.show();
			}
			else
			{
				collapseInstance?.hide();
			}

			const previouslyHiredYes = document.getElementById("PreviouslyHiredYes") as HTMLInputElement;
			const previouslyHiredNo = document.getElementById("PreviouslyHiredNo") as HTMLInputElement;

			if (method === "Previously Worked at FUN.com" && previouslyHiredYes)
			{
				previouslyHiredNo.checked = false;
				previouslyHiredNo.dispatchEvent(new Event("click", { bubbles: true }));
				previouslyHiredYes.checked = true;
				previouslyHiredYes.dispatchEvent(new Event("click", { bubbles: true }));
			}
		});
	};

	private ConfigureWorkLocation = () =>
	{
		document.querySelectorAll("input[name='WorkLocation']")?.forEach(input =>
		{
			input.addEventListener("change", (e) =>
			{
				const selected = document.querySelector("input[name='WorkLocation']:checked") as HTMLInputElement;
				const phone = selected.getAttribute("data-phone");

				if (phone !== "" && phone !== null)
				{
					const parser = new DOMParser();
					const parsedPhone = parser.parseFromString(phone, "text/html");
					const phoneLink = parsedPhone.body.textContent;

					// Update all hrPhone elements with the correct phone for the selected location
					document.querySelectorAll('.hrPhone').forEach(el =>
					{
						el.innerHTML = phoneLink || "";
					});
				}
			});
		});
	}
}